export class OrganizationService {
  static $inject = ['$http'];

  constructor(private $http) { }

  addMember(organizationShortName, orgMember) {
    return this.$http
      .post(`/api/organizations/${organizationShortName}/members`, orgMember)
      .then((res) => res.data);
  }

  getMembers(organizationShortName) {
    return this.$http
      .get(`/api/organizations/${organizationShortName}/members`)
      .then((res) => res.data);
  }

  removeMember(organizationShortName, orgMember) {
    return this.$http.delete(
      `/api/organizations/${organizationShortName}/members/${orgMember.member.id}`,
    );
  }

  updateRole(organizationShortName, orgMember) {
    return this.$http.put(
      `/api/organizations/${organizationShortName}/members/${orgMember.member.id}/role`,
      { role: orgMember.role },
    );
  }
}
